import React, { useContext } from "react";
import UserItem from "./UserItem";
import SkeletonUserCard from "../layouts/SkeletonUserCard";
import GithubContext from "../../context/github/githubContext";

const Users = () => {
  const githubContext = useContext(GithubContext);
  const { loading, users, clicked } = githubContext;

  if (loading) {
    return (
      <div className="user-grid">
        {[...Array(9)].map((_, i) => (
          <SkeletonUserCard key={i} />
        ))}
      </div>
    );
  }

  return (
    <div className="user-grid fade-in">
      {users.length === 0 && clicked === true ? (
        <div className="no-results">No users found.</div>
      ) : (
        users.map((user) => <UserItem key={user.id} user={user} />)
      )}
    </div>
  );
};

export default Users;
